import React, { FC, ReactNode } from "react";
import { useHistory } from "react-router-dom";
import InlineSvg from "Shared/components/inline-svg";
import Spinner from "Shared/components/spinner";
import TextLink from "Shared/components/text-link";
import { joinClassNames as c } from "Shared/util/styles";
import { Nothing } from "Shared/util/types";
import PageTitle from "./page-title";
import styles from "./page.css";

type Title =
    | string
    | {
          className?: string;
          reducedMarginBottom: boolean;
          text: string;
      };

type ReturnLinkProps = {
    path: string;
    text: string;
};

type PageProps = {
    children: ReactNode;
    loading?: boolean;
    narrowWidth?: boolean;
    returnLink?: ReturnLinkProps;
    title?: Title;
};

const renderPageTitle = (title: Title | Nothing) => {
    if (!title) return null;

    return typeof title === "string" ? (
        <PageTitle text={title} />
    ) : (
        <PageTitle
            className={title?.className}
            reducedMarginBottom={title?.reducedMarginBottom}
            text={title?.text}
        />
    );
};

const ReturnLink: FC<ReturnLinkProps> = ({ path, text }) => {
    const { push } = useHistory();

    const handleTextLinkClicked = () => push(path || "/");

    return (
        <TextLink
            className={styles.returnTextLink}
            link={handleTextLinkClicked}
            text={
                <>
                    <InlineSvg className={path} src="/arrow-back.svg" />
                    {text || "?"}
                </>
            }
        />
    );
};

const Page: FC<PageProps> = ({
    children,
    loading = false,
    narrowWidth = false,
    returnLink,
    title,
}) => (
    <div>
        {returnLink && (
            <div
                className={c(
                    styles.returnTextLinkContainer,
                    styles.fullPageSize,
                )}
            >
                <ReturnLink path={returnLink.path} text={returnLink.text} />
            </div>
        )}
        <div
            className={c(
                styles.pageContainer,
                styles.fullPageSize,
                narrowWidth && styles.narrowWidth,
            )}
        >
            {renderPageTitle(title)}
            {loading ? <Spinner /> : children}
        </div>
    </div>
);

export default Page;
